export type FeatureSubCategoryGroup<T> = {
  /**
   * Subcategory key, `other` for items without a subcategory of the given category.
   */
  key: string;
  label: string | null;
  isOther: boolean;
  items: T[];
};
